import React from "react";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { IsAlert } from "../component/atoms/IsAlert";
import { fetchApi } from "../helper/api";
const Login = () => {
  const navigate = useNavigate();
  const [values, setValues] = React.useState({
    amount: "",
    username: "",
    password: "",
    weight: "",
    weightRange: "",
    showPassword: false,
    errorMessage: "",
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleUsername = (e) => {
    var username_val = e.target.value;
    setValues({
      ...values,
      username: username_val,
    });
  };
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      // console.log('enter press here! ')
      handleLogin()
    }
  }
  const handleLogin = async () => {
    var role = values.username;
    role = role.split("@");
    localStorage.setItem("role", role[0]);
    var req = await fetchApi("api/Auth/login", "POST", false, {
      email: values.username,
      password: values.password,
    });
    var res = await req.json();
    var status = req.status;
    if (status !== 200) {
      setValues({
        ...values,
        errorMessage: res.message,
      });
    } else {
      document.cookie = `token=${res.data.token}; expires=${new Date(
        res.data.expiredTime
      )}`;
      navigate("/structure-monitor");
    }
  };
  return (
    <div className="bg_login row align-items-center m-0 justify-content-center">
      <div className="wrap_login col-lg-3 col-11 shadow p-4 bg-white rounded">
        <div className="row justify-content-center mb-4">
          <div className="logo_login col-8">
            <img
              alt=""
              className="w-100"
              src="https://connect-assets.prosple.com/cdn/ff/BxxWcDLuMPteTaLBarie733WNjM1w2h2okOUBO01EpY/1636517739/public/2021-11/banner%20for%20PUPR%20893x321.png"
            />
            <h2
              className="text-center mb-0"
              style={{
                lineHeight: 1.1,
                fontFamily: "sans-serif",
                fontSize: "22.2px",
                fontWeight: "800",
              }}
            >
              BBPJN SUMSEL
            </h2>
          </div>
        </div>
        <h1 className="mb-0">Login</h1>
        <p className="text-danger">{values.errorMessage}</p>
        <div className="py-2">
          <TextField
            onChange={handleUsername}
            value={values.username}
            className="w-100"
            label="Username / Email"
            variant="standard"
            autoComplete="off"
          />
        </div>
        <div className="py-2">
          <FormControl sx={{ width: "100%" }} variant="standard">
            <InputLabel htmlFor="standard-adornment-password">
              Password
            </InputLabel>
            <Input
              id="standard-adornment-password"
              type={values.showPassword ? "text" : "password"}
              value={values.password}
              onChange={handleChange("password")}
              onKeyPress={(e) => handleKeyPress(e)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {values.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>
        <div className="d-flex justify-content-end mb-4">
          <Link to="/lupa-password" className="text-success">
            Lupa Password?
          </Link>
        </div>
        <div className="py-2">
          <Button
            className="w-100"
            variant="contained"
            color="success"
            onClick={handleLogin}
          >
            <i className="las la-sign-in-alt mr-2"></i>
            Login
          </Button>
        </div>
        <p className="text-center py-2">
          Belum punya akun? klik daftar dibawah ini
        </p>
        <div className="py-2">
          <Button
            className="w-100"
            variant="contained"
            color="primary"
            onClick={() => navigate("/daftar")}
          >
            <i className="las la-user-plus mr-2"></i>
            Daftar
          </Button>
        </div>
      </div>
    </div>
  );
};
export default Login;
